<div class="flex-x flex-l flex-m flex-middle-x flex-middle-l block-s p-l-2-s p-r-2-s">

    <!-- Icon -->
    <div class="flex flex-noshrink m-r-2 inline-block-s float-left-s"
         [style.width.px]="44"
         [style.height.px]="44">
        <img src="/assets/images/warning.svg"
             alt="Warning Icon" />
    </div>

    <!-- Content -->
    <div class="flex-grow">
        <p class="p1">
            <strong class="s1">{{ 'WARNING' | translate }}:</strong> {{notice}}
        <br *ifSize="'!S'">
            {{ ('For more information go to' | translate) + ' ' }}
            <a class="s1 col-2 link"
               [href]="'https://' + warningUrl"
               target="_blank"
               rel="noopener noreferrer">{{warningUrl}}</a>.
        </p>
    </div>
</div>
